<script type="ts">
    import {isInvalid} from 'svelte-yup'; 

    export let schema;
    export let fields;
    export let fieldname;
    export let placeholder;
    export let labelName;
    export let dataText;    
    export let inputType;

    let invalid = false;
    let errors = [];

    async function validate(){        
        invalid = isInvalid(schema, fieldname, fields)        
        try {
            let t = await schema.validateAt(fieldname, fields)
            errors = []
        } catch(error){
            errors = error.errors
        }
    }
    
    function formatCurrency(){          
        fields.investmentAmount = parseInt(formatNumber(fields.investmentAmountString));   
        validate(); 
        fields.investmentAmountString =  formatterD.format(parseInt(fields.investmentAmount));
    }
    function formatNumber(number) {   
        let index = number.indexOf('.')  
        if(index >-1){
            number = number.substring(0, index)
        }
        return number.replace(/\D/g, "");
    }
    const formatterD = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });     

    $: valid = (name)=>{               
        return !isInvalid(schema, name, fields);
    }     
</script>
{#if inputType=="textbox"}
    <div class="form-group">
        <div class="spacer">
            {#if dataText.length > 0}
                <label for=fieldname class="label">{labelName}<span class="info-tooltip" data-text={dataText}><span class="info">info</span></span></label>
            {:else}
                <label for=fieldname class="label">{labelName}</label>
            {/if}          
        </div>  
            <input id={fieldname} type="text" class="form-control textbox" class:invalid={invalid} class:valid={valid(fieldname)} placeholder = {placeholder} bind:value={fields[fieldname]} on:blur={validate}>
            <p class="invalid" class:show={errors.length > 0} style="color:red">{errors[0]}</p>
    </div>
{/if}
<!-- This currently only works for investment amount -->
{#if inputType=="currency"}
    <div class="form-group">
        <div class="spacer">
            <label for=fieldname class="label">{labelName}</label>
        </div>  
            <input id={fieldname} type="text" class="form-control textbox" class:invalid={invalid} class:valid={valid(fieldname)} placeholder = {placeholder} bind:value={fields["investmentAmountString"]} on:input={validate} on:blur={formatCurrency}>
            <p class="invalid" class:show={errors.length > 0} style="color:red">{errors[0]}</p>
    </div>
{/if}
<style type="scss">
    .valid{
        border-color: #50C3FF ;   
    }
    .invalid {
        border-color: red !important;   
        color:red !important;         
    } 
    p.invalid {
        display: none;    
        font-size: 14px;
        margin-top:10px;
    }   
    p.invalid.show {
        display: block;
    }
    .form-group{
        margin-top: 12px;
        margin-bottom: 12px;
    }
    .form-group:first-child{
        margin-top: 0;
        position: relative;
    }
    input {
        width:100% !important;
        max-height: 48px;       
        height:48px;
        border: 1px solid #C6C6C6;
        border-radius: 100px;
        margin-top: 8px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 30px;  
        background-color: #FFFFFF;    
    }
    input:focus {
        border: #50C3FF 1px solid;
        outline-offset: 0px !important;
        outline: none !important;
    }
</style>